import { faCircleInfo } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  FormControl,
  Grid,
  InputLabel,
  TextField,
  Tooltip
} from '@mui/material';
import { useColorScheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
import { useFormContext } from 'react-hook-form';

import { isCustomerCloudSourcePageAtom } from '@/pages/Administration/Devices/Devices.store';

import {
  showInfoIconCommonIngestFromAtom,
  sourceDialogModeAtom
} from '../SourceCreate.store';
import useStyles from '../SourceCreate.styles';
import { SourceDialogMode } from '../SourceCreate.types';
import type { DynamicFormFieldProps } from './DynamicFormField.types';

const DynamicFormField = ({
  children,
  formField,
  xs,
  sm,
  md,
  isRequired
}: DynamicFormFieldProps) => {
  const { mode: themeMode } = useColorScheme();
  const { classes } = useStyles({ themeMode });
  const { register } = useFormContext();
  const [mode] = useAtom(sourceDialogModeAtom);
  const [isCustomerCloudSourcePage] = useAtom(isCustomerCloudSourcePageAtom);
  const [showInfoIconCommonIngestFrom] = useAtom(
    showInfoIconCommonIngestFromAtom
  );

  if (formField.type === 'hidden') return null;
  const required = isRequired ?? !formField.nonMandatory;

  const showCommonIngestFromInfoIcon =
    formField.name === 'common_ingest_from' &&
    mode === SourceDialogMode.Edit &&
    showInfoIconCommonIngestFrom;
  const showExpireDateInfoIcon =
    formField.name === 'expires' && !required && !formField.softExpiry;
  const showInfoIcon = showCommonIngestFromInfoIcon || showExpireDateInfoIcon;
  const tooltipTitle = showExpireDateInfoIcon
    ? 'Leave this field empty if the secret does not expire.'
    : "Please refer to the individual data providers for the 'Ingest from' date.";

  // changing label from 'Time Interval' to 'Polling Interval'
  const formatLabel = (lbl: string): string =>
    lbl.includes('Time Interval') ? 'Polling Interval' : lbl;

  return (
    <>
      {isCustomerCloudSourcePage &&
        ['ingest_from', 'common_ingest_from'].some((name) =>
          formField.name.endsWith(name)
        ) && (
          <div style={{ display: 'none' }}>
            <TextField type="hidden" {...register(formField.name)} />
          </div>
        )}

      {((isCustomerCloudSourcePage &&
        !['ingest_from', 'common_ingest_from'].some((name) =>
          formField.name.endsWith(name)
        )) ||
        !isCustomerCloudSourcePage) && (
        <Grid size={{ xs, sm, md }} key={formField.name}>
          <InputLabel htmlFor={`${formField.name}-input`}>
            {formatLabel(formField.label)}
            {required && (
              <span aria-hidden="true" title="Required">
                {' '}
                *
              </span>
            )}
            {showInfoIcon && (
              <>
                {' '}
                <Tooltip
                  placement="bottom"
                  classes={{ tooltip: classes.ingestFromInfoTooltip }}
                  title={tooltipTitle}
                >
                  <FontAwesomeIcon
                    icon={faCircleInfo}
                    className={classes.ingestFromInfoIcon}
                    style={{ cursor: 'pointer' }}
                  />
                </Tooltip>
              </>
            )}
          </InputLabel>

          <FormControl className={classes.widthFull}>{children}</FormControl>
        </Grid>
      )}
    </>
  );
};
export default DynamicFormField;
